export enum SavedSearchApiPath {
  SAVED_SEARCH = 'irent/User/search',
}
